module.exports = __webpack_public_path__ + "img/pic_27_dragdrop.9a19f7af.png";